<template>
  <div
    :id="data? data.url: ''"
    class="page"
  >
    <template v-if="!loading">
      <section
        id="content_section"
        class="container bg-white text-left"
      >
        <div class="row">
          <div
            class="py-4 pb-5"
            :class="page.sidemenu? 'col-lg-9 order-lg-2': 'col-lg-12 px-5'"
          >
            <Breadcrumb :items="breadcrumb" />
            <div class="content py-4">
              <h1
                v-if="page.heading"
                class="articleTitle text-osc"
              >
                {{ page.heading }}
              </h1>
              <div
                v-if="!loading && data"
                class="articleBodyFullWidth"
              >
                <div
                  v-if="page.heading"
                  class="articleLike mb-4"
                >
                  <ShareBtn />
                </div>
                <div
                  v-if="data.image"
                  v-lazy-container="{ selector: 'img' }"
                  class="mb-3"
                >
                  <img
                    class="hero_image"
                    :data-src="getAssetLink(data.image)"
                    :data-loading="$config.lazyload.banner"
                  >
                </div>
                <div class="articleContent">
                  <div
                    v-if="data.body"
                    v-lazy-container="{ selector: 'img' }"
                    v-html="filterHTML(data.body)"
                  />
                </div>
              </div>
            </div>
          </div>
          <SideMenu
            v-if="page.sidemenu"
            class="col-lg-3 py-4 order-lg-1"
            :data="page.sidemenu"
          />
        </div>
      </section>
      <section
        id="donate_btn_section"
        class="container bg-white py-4 clearfix d-none d-md-block"
      >
        <DonateBtn
          v-view.once
          class="animated fadeInRight"
        />
      </section>
    </template>
  </div>
</template>
<script>
import DonateBtn from "@/components/DonateBtn.vue";
import SideMenu from "@/components/SideMenu.vue";
import ShareBtn from "@/components/ShareBtn.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";

export default {
  name: "Article",
  components: { DonateBtn, SideMenu, ShareBtn, Breadcrumb },
  data() {
    var to = this.$router.history.current;
    return {
      // default
      params: this.getParams(to),
      path: to.path,
      loading: true,
      page: null,
      data: null,
      breadcrumb: []
    };
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
      if (from.params.type != to.params.type) {
        this.params = this.getParams(to);
        this.init();
      } else {
        this.params = this.getParams(to);
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    getParams(to) {
      return { type: to.params.type, id: to.params.id };
    },
    init() {
      this.loading = true;

      this.page = {
        // Default Settings for page
        sidemenu: null,
        title: this.$t("page." + this.params.type),
        heading: null
      };
      this.$http
        .get(`${this.params.type}/detail/${this.params.id}`)
        .then(response => {
          if (response.data.success) {
            this.data = response.data.data;

            this.page.heading =
              this.getDataValue("headline", this.data) || this.page.heading;
            this.$route.meta.title = this.page.title;
            this.$meta().refresh(); // Important!

            if (this.data && this.data.left_menus) {
              if (this.data.tab_menus && this.data.tab_menus.length > 0) {
                if (this.data.left_menus && this.data.left_menus.length > 0) {
                  let item = {
                    url: "news",
                    name: "SCMP",
                    type: "list",
                    sub_menus: this.data.tab_menus
                  };
                  this.data.left_menus.unshift(item);
                } else {
                  this.data.left_menu_header = this.$t("component.category");
                  this.data.left_menus = this.data.tab_menus;
                }
              }
              this.page.sidemenu = {
                parent: this.path,
                title: this.data.left_menu_header,
                items: this.data.left_menus
              };
            }
          } else {
            if (typeof response.data == "string") {
              throw new Error(response.data);
            } else {
              throw new Error(response.data.error);
            }
          }
        })
        .catch(error => {
          let response = error.response;
          if (
            response &&
            (response.status === 404 || response.status === 401)
          ) {
            this.$router.replace("/404");
          }
        })
        .finally(() => {
          this.breadcrumb = [
            {
              name: this.$t("page." + this.params.type),
              url: "/" + this.params.type
            },
            { name: this.page.heading, url: this.path }
          ];
          this.scrollTo("body");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.hero_image {
  max-height: 500px;
}
</style>
